import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import cn from 'classnames';

import * as styles from './styles.css';

export const FormFailedContent: React.FC = ({ children }) => {
  const isMobile = useDeviceType() === 'phone';

  return <div className={cn(styles['content'], isMobile && styles['content-mobile'])}>{children}</div>;
};
